import { render, staticRenderFns } from "./TabellaButtonAuth.vue?vue&type=template&id=1a6fcbd4&"
import script from "./TabellaButtonAuth.vue?vue&type=script&lang=js&"
export * from "./TabellaButtonAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports